/** Page chrome behind splash — cream, not maroon (avoids flash after splash fades). */
export const SPLASH_PAGE_BG = '#fdf8f0';

export function releaseSplashChrome() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.remove('daiv-splash-active');
  document.documentElement.style.backgroundColor = SPLASH_PAGE_BG;
  document.body.style.backgroundColor = SPLASH_PAGE_BG;
}

export function holdSplashChrome() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.add('daiv-splash-active');
}

/** Best-effort route warm-up — never throw (stale dev chunks on hover must not crash the app). */
function prefetchImport(loader) {
  try {
    const p = loader();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {});
    }
  } catch {
    /* ignore */
  }
}

export function prefetchRouteForPath(pathname) {
  const path = pathname || '/';
  if (path === '/' || path === '') {
    prefetchImport(() => import('../pages/Home'));
    return;
  }
  if (path.startsWith('/astrology')) {
    prefetchImport(() => import('../pages/Astrology'));
    return;
  }
  if (path.startsWith('/poojas') || path.startsWith('/past') || path.startsWith('/upcoming')) {
    prefetchImport(() => import('../pages/Poojas'));
    return;
  }
  if (path.startsWith('/gallery')) {
    prefetchImport(() => import('../pages/Gallery/Gallery'));
    return;
  }
  if (path.startsWith('/store')) {
    prefetchImport(() => import('../pages/Store'));
    return;
  }
  if (path.startsWith('/daiv-nitya')) {
    prefetchImport(() => import('../pages/DaivNitya'));
    return;
  }
  if (path.startsWith('/live-tv')) {
    prefetchImport(() => import('../pages/LivePooja'));
    return;
  }
  if (path.startsWith('/pooja/')) {
    prefetchImport(() => import('../pages/PoojaDetail'));
    return;
  }
  if (path.startsWith('/about')) {
    prefetchImport(() => import('../pages/About'));
    return;
  }
  if (path.startsWith('/temple')) {
    prefetchImport(() => import('../pages/Temple'));
    return;
  }
  prefetchImport(() => import('../pages/Home'));
}

/** Warm route JS on nav hover (faster first paint on About, etc.). */
export function prefetchRouteChunk(pathname) {
  if (typeof window === 'undefined') return;
  prefetchRouteForPath(pathname);
}
